import stripePrices from '@/config/stripe_prices.json'

/**
 * Vérifie si une configuration Stripe (Price / Link) existe pour ce produit et cette devise
 */
export function hasStripePrice(productId, currency) {
  const productPrices = stripePrices[productId];
  return !!(productPrices && productPrices[currency.toLowerCase()]);
}

/**
 * Adaptateur Stripe (via Payment Links générés par le script)
 */
export async function processStripe({ currency, customer, productId }) {
  console.log('🚀 Redirecting to Stripe Payment Link...', { productId, currency });

  try {
    const productPrices = stripePrices[productId];
    const priceData = productPrices ? productPrices[currency.toLowerCase()] : null;
    
    // Le nouveau format généré par syncStripePrices.js est un objet { priceId, url }
    let linkUrl = null;
    if (typeof priceData === 'object' && priceData !== null && priceData.url) {
      linkUrl = priceData.url;
    }

    if (!linkUrl) {
      throw new Error(`Aucun lien de paiement Stripe trouvé pour ${productId} en ${currency}. Veuillez ré-exécuter le script de synchronisation (syncStripePrices.js).`);
    }

    // Ajout de l'email du client pré-rempli pour lui faciliter la vie
    const finalUrl = new URL(linkUrl);
    if (customer && customer.email) {
      finalUrl.searchParams.append('prefilled_email', customer.email);
    }

    // Redirection native vers le lien de paiement Stripe
    window.location.href = finalUrl.toString();

    // La page va être déchargée, on empêche le code appelant de croire que le paiement est déjà validé
    return { success: false, pendingRedirect: true };
  } catch (error) {
    console.error('❌ Stripe Error:', error);
    return { success: false, error: error.message };
  }
}
